import IoTConnection from '../frontend-common-libs/src/iot/IoTConnection';

export default new IoTConnection();
